import {
  INPUT_CC_NUMBER,
  INPUT_CC_EXPIRATION_MONTH,
  INPUT_CC_EXPIRATION_YEAR,
  INPUT_CC_SECURITY_CODE,
  INPUT_FIRST_NAME,
  INPUT_LAST_NAME,
  INPUT_EMAIL_ADDRESS,
  INPUT_PHONE_NUMBER,
  INPUT_BILLING_ADDRESS,
  INPUT_BILLING_COUNTRY,
  INPUT_BILLING_ZIP,
  INPUT_BILLING_CITY,
  INPUT_BILLING_STATE,
} from '../constants/checkout'

export const getStatus = state => state.checkout.status
export const getFocusedInput = state => state.checkout.focusedInput
export const getCCNumber = state => state.checkout[INPUT_CC_NUMBER]
export const getCCExpirationMonth = state => state.checkout[INPUT_CC_EXPIRATION_MONTH]
export const getCCExpirationYear = state => state.checkout[INPUT_CC_EXPIRATION_YEAR]
export const getCCSecurityCode = state => state.checkout[INPUT_CC_SECURITY_CODE]
export const getFirstName = state => state.checkout[INPUT_FIRST_NAME]
export const getLastName = state => state.checkout[INPUT_LAST_NAME]
export const getEmailAddress = state => state.checkout[INPUT_EMAIL_ADDRESS]
export const getPhoneNumber = state => state.checkout[INPUT_PHONE_NUMBER]
export const getBillingAddress = state => state.checkout[INPUT_BILLING_ADDRESS]
export const getBillingCountryId = state => state.checkout[INPUT_BILLING_COUNTRY]
export const getBillingCountryName = state => {
  if (state.checkout.countriesById[state.checkout[INPUT_BILLING_COUNTRY]] !== undefined) {
    return state.checkout.countriesById[state.checkout[INPUT_BILLING_COUNTRY]]
  } else {
    return ''
  }
}
export const getBillingCountryCode = state => {
  if (
    state.checkout.countryCodesById[state.checkout[INPUT_BILLING_COUNTRY]] !== undefined
  ) {
    return state.checkout.countryCodesById[state.checkout[INPUT_BILLING_COUNTRY]]
  } else {
    return ''
  }
}
export const getBillingCountryIds = state => state.checkout.countries
export const getBillingCountriesByIds = state => state.checkout.countriesById
export const getBillingZip = state => state.checkout[INPUT_BILLING_ZIP]
export const getBillingCity = state => state.checkout[INPUT_BILLING_CITY]
export const getBillingState = state => state.checkout[INPUT_BILLING_STATE]
export const getCCNumberError = state => state.checkout.errors[INPUT_CC_NUMBER]
export const getCCExpirationMonthError = state =>
  state.checkout.errors[INPUT_CC_EXPIRATION_MONTH]
export const getCCExpirationYearError = state =>
  state.checkout.errors[INPUT_CC_EXPIRATION_YEAR]
export const getCCSecurityCodeError = state =>
  state.checkout.errors[INPUT_CC_SECURITY_CODE]
export const getFirstNameError = state => state.checkout.errors[INPUT_FIRST_NAME]
export const getLastNameError = state => state.checkout.errors[INPUT_LAST_NAME]
export const getEmailAddressError = state => state.checkout.errors[INPUT_EMAIL_ADDRESS]
export const getPhoneNumberError = state => state.checkout.errors[INPUT_PHONE_NUMBER]
export const getBillingAddressError = state =>
  state.checkout.errors[INPUT_BILLING_ADDRESS]
export const getBillingCountryError = state =>
  state.checkout.errors[INPUT_BILLING_COUNTRY]
export const getBillingZipError = state => state.checkout.errors[INPUT_BILLING_ZIP]
export const getBillingCityError = state => state.checkout.errors[INPUT_BILLING_CITY]
export const getBillingStateError = state => state.checkout.errors[INPUT_BILLING_STATE]
export const getKeyboardFocused = state => state.checkout.keyboardFocused
export const getFocusedRow = state => state.checkout.focusedRow
export const getFocusedCol = state => state.checkout.focusedCol
export const getFailedMessage = state => state.checkout.failedMessage
export const isAccountDetailsReady = state => state.checkout.isAccountDetailsReady

export const getBillingCountries = state => {
  const countryIds = getBillingCountryIds(state)
  const countriesByIds = getBillingCountriesByIds(state)
  return countryIds.map(id => ({
    value: id,
    label: countriesByIds[id],
  }))
}

export const getTermsField = state => state.checkout.termsField

export const getDictionary = state => state.checkout.dictionary
